<template>
        <div class="container mt-5">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-3 py-3">
                    <bootstrap-alert 
                        :variant="variant"
                        :msg="$t('Your Order has been placed successfully')" 
                        :errorMsg="errors" 
                    />

                    <div class="px-4 px-lg-0">
                        <div class="pb-5">
                            <div class="row mx-0">
                                <div class="col-lg-12 bg-white mb-2 p-3 border">
                                    <h3>{{ $t('Thank You for Purchase') }}</h3>
                                    <div v-if="orderno">
                                        <p>{{ $t('Your order no is ') }} {{orderno}}</p>
                                    </div>
                                    <div v-else>
                                        <p>{{ $t('Thank you for your purchase.') }}</p>
                                    </div>
                                </div>
                                <router-link 
                                    tag="button" 
                                    :to="{name : 'home' }"
                                    class="btn theme-btn btn-primary f-right"
                                    variant="primary">
                                    {{$t('Go to Home')}}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

export default {
    metaInfo: {
        title: 'Order Success',
        meta: [
            {name: 'description', content: 'Thank you for your purchase.'}
        ]
    },
    data() {
        return {
            errors: [],
            variant: 'success',
            orderno: ''
        }
    },
    created() {
        if (this.navisionOrderNo == '') {
            this.$router.push({ name: 'home', replace: true }).catch(err => {});
        }
    },
    computed: {
        ...mapGetters('cart', ['navisionOrderNo'])
    },
    mounted() {
        this.orderno = this.navisionOrderNo;
        this.resetNavision()
    },
    methods: {
        ...mapActions('cart', ['resetNavision']),
    },
};
</script>